<template>
  <h1>{{ $t("mis_datos.titulo") }}</h1>
  <div class="col-lg-12 col-md-12 col-xl-10 col-xxl-7">
    <div class="mensaje-informativo">
      <i class="fa fa-regular fa-info-circle"></i>
      <span v-html="$t('mis_datos.form.mensaje_informativo_email')"></span>
    </div>
    <DxForm id="formulario-datos-agente" ref="formInstance" :form-data="model" label-location="top"
      :show-colon-after-label="false" validation-group="validacion-datos-agente">
      <DxColCountByScreen :xs="6" :sm="6" :md="6" :lg="6" />

      <!-- Datos personales -->
      <DxGroupItem :col-count="6" :col-span="6">
        <DxSimpleItem data-field="Nombre" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('mis_datos.form.nombre')" />
          <DxRequiredRule :message="$t('mis_datos.form.validacion.nombre')" />
          <DxCustomRule
            :validation-callback="validarNombre"
            :message="$t('mis_datos.form.validacion.campo_no_modificable_tras_validacion')"
            :reevaluate="true"
          />
        </DxSimpleItem>
        <DxSimpleItem data-field="Apellidos" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('mis_datos.form.apellidos')" />
          <DxRequiredRule :message="$t('mis_datos.form.validacion.apellidos')" />
          <DxCustomRule
            :validation-callback="validarApellidos"
            :message="$t('mis_datos.form.validacion.campo_no_modificable_tras_validacion')"
            :reevaluate="true"
          />
        </DxSimpleItem>
        <DxSimpleItem data-field="Email" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('mis_datos.form.email')" />
          <DxRequiredRule :message="$t('mis_datos.form.validacion.email')" />
          <DxEmailRule :message="$t('mis_datos.form.validacion.email_patron')" />
          <DxCustomRule
            :validation-callback="validarEmail"
            :message="$t('mis_datos.form.validacion.campo_no_modificable_tras_validacion')"
            :reevaluate="true"
          />
        </DxSimpleItem>
        <DxSimpleItem data-field="Telefono" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('mis_datos.form.telefono')" />
          <DxRequiredRule :message="$t('mis_datos.form.validacion.telefono')" />
          <DxPatternRule :pattern="telefonoPattern" :message="$t('mis_datos.form.validacion.telefono_patron')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Documento" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('mis_datos.form.dni')" />
          <DxRequiredRule :message="$t('mis_datos.form.validacion.dni_nie')" />
          <DxPatternRule :pattern="dniNieNifPattern" :message="$t('mis_datos.form.validacion.dni_nie_patron')" />
          <DxCustomRule
            :validation-callback="validarDocumento"
            :message="$t('mis_datos.form.validacion.campo_no_modificable_tras_validacion')"
            :reevaluate="true"
          />
        </DxSimpleItem>
        <DxEmptyItem :col-span="3"></DxEmptyItem>
      </DxGroupItem>

      <!-- Dirección física -->
      <DxGroupItem :col-count="6" :col-span="6">
        <DxSimpleItem :col-span="6">
          <span class="dx-field-item-label-text text-success">{{
            $t("mis_datos.form.direccion_fisica")
          }}</span>
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.CodigoPostal" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('mis_datos.form.codigo_postal')" />
          <DxPatternRule :pattern="codigoPostalPattern" :message="$t('mis_datos.form.validacion.codigo_postal_patron')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Provincia" editor-type="dxTextBox" :col-span="2">
          <DxLabel :text="$t('mis_datos.form.provincia')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Municipio" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('mis_datos.form.municipio')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.TipoVia" editor-type="dxTextBox" :col-span="2">
          <DxLabel :text="$t('mis_datos.form.tipo_de_via')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.NombreVia" editor-type="dxTextBox" :col-span="4">
          <DxLabel :text="$t('mis_datos.form.nombre_via')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Numero" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('mis_datos.form.numero')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Escalera" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('mis_datos.form.escalera')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Piso" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('mis_datos.form.piso')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Puerta" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('mis_datos.form.puerta')" />
        </DxSimpleItem>
        <DxEmptyItem :col-span="2"></DxEmptyItem>
      </DxGroupItem>

      <!-- Botón de guardar -->
      <DxGroupItem :col-count="6" :col-span="6">
        <DxEmptyItem :col-span="4"></DxEmptyItem>
        <DxButtonItem :col-span="2" :button-options="optSaveButton"></DxButtonItem>
      </DxGroupItem>
    </DxForm>

  </div>
</template>
<script setup lang="ts">
import type { EditAgentePersonalDataModel } from "@/.shared/.api";
import { useApi } from "@/.shared/.api/integration";
import { USER_WITH_DUPLICATED_EMAIL } from "@/.shared/errors/codes";
import { saveButtonProps } from "@/.shared/helpers/button-helper";
import { ApiError } from "@/.shared/services/http";
import { useIntl } from "@/.shared/services/i18n";
import { toastError, toastSuccess } from "@/.shared/services/notification-service";
import {
  DxForm,
  DxItem,
  DxLabel,
  DxColCountByScreen,
  DxEmptyItem,
  DxButtonItem,
  DxRequiredRule,
  DxEmailRule,
  DxPatternRule,
  DxCustomRule,
  DxSimpleItem,
  DxGroupItem
} from "devextreme-vue/form";
import validationEngine from "devextreme/ui/validation_engine";
import { onMounted, ref } from "vue";
import type { DxButton } from "devextreme-vue";
import { useAuthentication } from "@/.shared/services/auth";
import {
  crearValidadorCampoInmutable,
  useEmpresaAgentesCamposIdentidadBloqueados,
} from "@/composables/empresaAgentesCamposIdentidadBloqueados";
import { recargarDatosEmpresaMisDatos } from "@/composables/misDatosRecargaEmpresa";

const model = ref();
const datosOriginales = ref<{ Nombre?: string; Apellidos?: string; Email?: string; Documento?: string }>();
const { camposIdentidadBloqueados } = useEmpresaAgentesCamposIdentidadBloqueados();
const validarNombre = crearValidadorCampoInmutable(() => datosOriginales.value?.Nombre, camposIdentidadBloqueados);
const validarApellidos = crearValidadorCampoInmutable(() => datosOriginales.value?.Apellidos, camposIdentidadBloqueados);
const validarEmail = crearValidadorCampoInmutable(() => datosOriginales.value?.Email, camposIdentidadBloqueados);
const validarDocumento = crearValidadorCampoInmutable(() => datosOriginales.value?.Documento, camposIdentidadBloqueados);
const formInstance = ref<DxForm>();
const api = useApi();
const intl = useIntl();
const dniNieNifPattern = ref<RegExp>(/(^\d{8}[A-Za-z]$)|(^[A-Za-z]\d{7}[A-Za-z0-9]$)/);
const telefonoPattern = ref<RegExp>(/^\d{9}$/);
const codigoPostalPattern = ref<RegExp>(/^\d{5}$/);

const auth = useAuthentication();

onMounted(() => {
  api.callStandardApi('getCurrentAgentePersonalData', { showLoading: true })
    .then(data => {
      model.value = data;
      datosOriginales.value = {
        Nombre: data.Nombre,
        Apellidos: data.Apellidos,
        Email: data.Email,
        Documento: data.Documento,
      };
    })
    .catch();
});

const optSaveButton = {
  ...saveButtonProps(),
  onClick: async function () {
    await save();
  }
};


const optSignOutButton: DxButton = {
  text: intl.i18n.t("shared.ui.buttons.logout"),
  icon: "fa-light fa-sign-out",
  onClick: async function () {
    auth.logout(import.meta.env.VITE_BASE_URL);
  }
};

const save = async () => {
  var resDatosAgente = validationEngine.validateGroup("validacion-datos-agente");

  if (resDatosAgente.isValid) {
    try {
      await api.callStandardApi("editCurrentAgentePersonalData", { showLoading: true }, model.value as EditAgentePersonalDataModel)
        .then(() => toastSuccess(intl.i18n.t('mis_datos.edicion_exito')))

      await refrescarDatos();
      await recargarDatosEmpresaMisDatos();
    }
    catch (e: any) {
      if (e instanceof ApiError && e.details?.errorList.length === 1 && [USER_WITH_DUPLICATED_EMAIL].includes(e.details.errorList[0].Code))
        toastError(intl.i18n.t(`shared.errors.api.${e.details.errorList[0].Code}`))
      else throw e;
      return false;
    }
  } else {
    toastError(intl.i18n.t('mis_datos.revise_validacion'));
  }
  return false;
}

const refrescarDatos = async () => {
  await api.callStandardApi('getCurrentAgentePersonalData', { showLoading: false })
    .then(data => {
      model.value = data;
      datosOriginales.value = {
        Nombre: data.Nombre,
        Apellidos: data.Apellidos,
        Email: data.Email,
        Documento: data.Documento,
      };
    })
    .catch();
}

</script>
<style lang="scss" scoped>
.mensaje-informativo {
  margin-bottom: 16px;

  i {
    margin-right: 6px;
  }
}
</style>
